var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolBookingRequests01 = function SvgSolBookingRequests01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_booking_requests-01_svg2__a",
    x1: 138.75,
    x2: 45.01,
    y1: 196.04,
    y2: -11.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_booking_requests-01_svg2__a",
    id: "sol_booking_requests-01_svg2__b",
    x1: 202.38,
    x2: 108.64,
    y1: 167.34,
    y2: -40.47
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_booking_requests-01_svg2__a",
    id: "sol_booking_requests-01_svg2__c",
    x1: 186.62,
    x2: 92.87,
    y1: 174.45,
    y2: -33.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_booking_requests-01_svg2__a",
    id: "sol_booking_requests-01_svg2__d",
    x1: 223.34,
    x2: 129.59,
    y1: 157.89,
    y2: -49.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_booking_requests-01_svg2__a",
    id: "sol_booking_requests-01_svg2__e",
    x1: 164.41,
    x2: 70.67,
    y1: 184.46,
    y2: -23.35
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M84.48 26c-7.01 0-12.96 4.63-14.95 10.99-2-6.36-7.94-10.99-14.95-10.99-8.64 0-15.67 7.03-15.67 15.67 0 .52.03 1.03.08 1.53-.7-1.3-1.68-2.43-2.87-3.28a8.94 8.94 0 0 0 1.49-4.95c0-4.95-4.02-8.97-8.97-8.97h-7.13c-1.61 0-2.91 1.3-2.91 2.91v25.51c0 1.61 1.3 2.91 2.91 2.91h9.01c5.3 0 9.61-4.31 9.61-9.61v-.01c2.37 5.65 7.96 9.63 14.46 9.63 7.01 0 12.96-4.63 14.95-10.99 2 6.36 7.94 10.99 14.95 10.99 7.46 0 13.71-5.25 15.28-12.24v9.33c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91v-7.15l9.07 9.19c.57.58 1.32.87 2.07.87s1.48-.28 2.05-.84a2.91 2.91 0 0 0 .03-4.12l-10.57-10.71 10.57-10.71a2.91 2.91 0 0 0-.03-4.12 2.91 2.91 0 0 0-4.12.03l-9.07 9.19v-7.15c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v9.33c-1.57-7-7.82-12.25-15.28-12.25Zm-55.85 5.82c1.73 0 3.14 1.41 3.14 3.14s-1.41 3.14-3.14 3.14h-4.22v-6.29h4.22Zm1.88 19.69h-6.09v-7.57h6.09c2.09 0 3.79 1.7 3.79 3.79s-1.7 3.79-3.79 3.79Zm24.06 0c-5.43 0-9.85-4.42-9.85-9.84s4.42-9.84 9.85-9.84 9.85 4.42 9.85 9.84-4.42 9.84-9.85 9.84m29.91 0c-5.43 0-9.85-4.42-9.85-9.84s4.42-9.84 9.85-9.84 9.84 4.42 9.84 9.84-4.42 9.84-9.84 9.84",
    style: {
      fill: "url(#sol_booking_requests-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.23 54.42V38.66l11.39 17.36a2.905 2.905 0 0 0 5.34-1.59V28.92c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v15.76l-11.39-17.36a2.916 2.916 0 0 0-5.35 1.6v25.51c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91Z",
    style: {
      fill: "url(#sol_booking_requests-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.72 57.34c1.61 0 2.91-1.3 2.91-2.91V28.92c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v25.51c0 1.61 1.3 2.91 2.91 2.91",
    style: {
      fill: "url(#sol_booking_requests-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.91 31.82c1.96 0 3.69 1.32 4.2 3.21a2.92 2.92 0 0 0 3.57 2.05 2.913 2.913 0 0 0 2.05-3.57c-1.19-4.42-5.23-7.51-9.82-7.51-5.61 0-10.17 4.56-10.17 10.17v10.99c0 5.61 4.56 10.17 10.17 10.17s10.17-4.56 10.17-10.17v-3.44c0-1.61-1.3-2.91-2.91-2.91h-4.44c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h1.53v.52c0 2.4-1.95 4.35-4.35 4.35s-4.35-1.95-4.35-4.35V36.16c0-2.4 1.95-4.35 4.35-4.35Z",
    style: {
      fill: "url(#sol_booking_requests-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 91.76c1.61 0 2.91-1.3 2.91-2.91v-5.51h32.82c9.15 0 16.59-7.44 16.59-16.59V16.59c0-9.15-7.44-16.59-16.59-16.59h-72.4c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h72.4c5.94 0 10.76 4.83 10.76 10.77v50.15c0 5.94-4.83 10.77-10.76 10.77H146.3c0-.05-.03-.1-.03-.15a12 12 0 0 0-.4-1.79c-.02-.05-.04-.1-.05-.15-.4-1.21-.99-2.34-1.73-3.33-.03-.04-.05-.08-.08-.11-.36-.47-.76-.91-1.19-1.32-.06-.05-.11-.11-.17-.16-.42-.39-.87-.74-1.35-1.07-.07-.05-.15-.1-.22-.15-.48-.31-.98-.58-1.51-.81-.08-.04-.16-.07-.24-.1-.54-.22-1.09-.41-1.67-.54-.06-.01-.13-.02-.19-.04-.6-.13-1.22-.21-1.85-.23h-.01c-2.9-.1-5.59.91-7.72 2.8-.13.11-.26.22-.39.34-.43.42-.82.88-1.17 1.35-.05.07-.11.14-.16.21-.33.46-.61.94-.86 1.44-.05.09-.09.19-.14.28-.24.51-.44 1.03-.6 1.57l-.06.22c-.15.55-.26 1.12-.33 1.7v.05H20.76C14.82 77.52 10 72.69 10 66.75V16.59c0-5.94 4.83-10.77 10.76-10.77h72.4c1.61 0 2.91-1.3 2.91-2.91S94.77 0 93.16 0h-72.4C11.62 0 4.17 7.44 4.17 16.59v50.15c0 9.15 7.44 16.59 16.59 16.59h103.35v49.9c0 .09 0 .35-.31.49-.31.15-.51-.03-.57-.08-4.29-3.67-10.87-8.53-17.79-10.81-4.32-1.43-8.95-.04-11.51 3.47-2.76 3.76-2.59 8.86.39 12.41 5.65 6.72 16.53 19.56 25.85 30.08 1.11 1.26 2.84 3.9 4.76 9.39 4.57 13.04 16.85 21.81 30.56 21.81 1.41 0 2.69 0 3.88.02h.25c9.5 0 18.8-3.85 25.52-10.57 5.98-5.98 9.69-13.9 10.43-22.31.17-1.86.25-3.62.25-5.09v-36.23c0-6.16-4.85-11.31-10.81-11.49-2.85-.09-5.61.91-7.74 2.81-1.97-2.84-5.15-4.74-8.73-4.85-2.9-.08-5.61.91-7.74 2.81-1.97-2.84-5.15-4.74-8.73-4.85-2-.05-3.95.41-5.66 1.34v-9.05c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v24.99c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91v-6.14c0-1.45.57-2.81 1.62-3.82a5.38 5.38 0 0 1 3.87-1.5c2.84.08 5.16 2.63 5.16 5.67v5.79c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91v-4.1c0-1.45.57-2.81 1.62-3.82 1.04-1.01 2.43-1.53 3.87-1.5 2.84.09 5.16 2.63 5.16 5.67v3.76c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91v-2.06c0-1.45.57-2.81 1.62-3.82 1.04-1.01 2.42-1.53 3.87-1.5 2.84.09 5.16 2.63 5.16 5.67v36.23c0 1.3-.08 2.88-.23 4.57a30.3 30.3 0 0 1-8.75 18.71c-5.64 5.64-13.43 8.87-21.4 8.87h-.21c-1.2 0-2.5-.02-3.92-.02-11.24 0-21.31-7.2-25.06-17.91-1.82-5.19-3.75-8.9-5.9-11.33-9.27-10.46-20.12-23.26-25.75-29.96-1.25-1.48-1.31-3.63-.14-5.22 1.05-1.43 3.09-2 4.99-1.38 6.02 1.99 11.93 6.38 15.83 9.71a6.3 6.3 0 0 0 6.79.94 6.31 6.31 0 0 0 3.7-5.78V78.72c0-.43.07-.85.16-1.25.23-.97.72-1.86 1.45-2.57 1.04-1.01 2.42-1.53 3.87-1.5.74.02 1.44.22 2.07.53 1.81.91 3.09 2.88 3.09 5.13v9.8c0 1.61 1.3 2.91 2.91 2.91Z",
    style: {
      fill: "url(#sol_booking_requests-01_svg2__e)"
    }
  }));
};
export default SvgSolBookingRequests01;